import { createStore } from 'vuex';
import moduleMain from '@/store/moduleMain';

const store = createStore({
  modules: {
    main: moduleMain
  }
});

export default store;
